import React from 'react';
import { Outlet } from 'react-router-dom';
import TripRequestsSubNavigation from '../../components/trip-requests/trip-requests-sub-navigation';

const View = () => (
  <>
    <TripRequestsSubNavigation />
    <Outlet />
  </>
);

export default View;
